/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pills2': {
    width: 16,
    height: 16,
    viewBox: '0 0 57.4 55.4',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M36.39 23.11l4.81-4.81a10.38 10.38 0 0 0 0-14.6l-.2-.2a10.38 10.38 0 0 0-14.6 0L3.5 26.4a10.38 10.38 0 0 0 0 14.6l.2.2a10.38 10.38 0 0 0 14.6 0l15.61-15.61M30.9 28.8L16.2 14.1M55 49.4a11.94 11.94 0 1 1 1.39-3M32.9 42.9h24"/><circle pid="1" class="cls-1" cx="52.4" cy="20.4" r="3.5"/><circle pid="2" class="cls-1" cx="24.4" cy="47.4" r="3.5"/><circle pid="3" class="cls-1" cx="8.4" cy="51.4" r="3.5"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/pills2.js